import React from "react";
import "./styles.css";

const MainLayout = ({children}) => {
  return <div className="page-content">{children}</div>;
};

export default MainLayout;
